const KEY_SCROLL = new Set(['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' ', 'Spacebar']);

export const preventScroll = (event: Event) => {
  event.preventDefault();
};

export const blockKeyScroll = (event: KeyboardEvent) => {
  if (KEY_SCROLL.has(event.key)) event.preventDefault();
};

export const isIOS = () => {
  return /iP(ad|hone|od)/.test(navigator.userAgent);
};
